import React from 'react';

import { Switch } from 'components/shared/Switch';

const SwitchField = ({
  readOnly,
  haveError,
  helpers,
  field,
  form,
  ...restProps
}: {
  readOnly: any;
  haveError: any;
  helpers: any;
  field: any;
  form: any;
} & Record<string, any>) => {
  const handleChange = (event: any) => {
    if (readOnly) {
      return;
    }

    helpers.setValue(event.target.checked);
  };

  return (
    <Switch
      {...restProps}
      readOnly={readOnly}
      checked={field.checked}
      name={field.name}
      onChange={handleChange}
    />
  );
};

export default React.memo(SwitchField) as any;
